import * as Yup from 'yup';

const validationSchema = () => {
  return Yup.object({
    accessCode: Yup.string().required('validation.required'), // t('validation.required') <- for i18n-unused
  });
};

export default validationSchema;
